import { Component, OnInit } from '@angular/core';

import { AuthService } from '../../shared/services/auth.service';

import { LayoutService } from '../../shared/services/layout.service';
import { ErrorService } from '../../shared/services/error.service';

@Component({
    selector: 'maintenance',
    templateUrl: 'maintenance.component.html'
})

export class MaintenanceComponent{
    vEmail: string;
    vPassword: string;

    constructor(
        private _layoutService: LayoutService,
        private _errorService: ErrorService,
        private _authService: AuthService
    ) {
        
    }

    ngOnInit() {
    	this._layoutService.setCurrentPage('maintenance');
        this._authService.resetError();
    }

    getErrorStatusAndMessage(){
        return this._errorService.getErrorStatusAndMessage();
    }

    getBackEndError() {
        return this._errorService.getBackEndError();
    }

    isDisableClick(){
        return ( this.vEmail === undefined || this.vEmail === '' ) || ( this.vPassword === undefined || this.vPassword === '' ) ? true: false;
    }

    getLoadingStatus(){
        return this._authService.getLoadingStatus();
    }

    login(){
        this._authService.checkLogin(this.vEmail, this.vPassword);
    }

}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/information/components/maintenance.component.ts